import React, { createContext } from "react";
import { IParentContextProps } from "./interface";

const ParentContext = createContext<IParentContextProps>(null as any);

const ParentContextProvider: React.FC<IParentContextProps> = ({
	children,
	...rest
}) => {
	return (
		<ParentContext.Provider value={{ ...rest }}>
			{children}
		</ParentContext.Provider>
	);
};

export { ParentContext, ParentContextProvider };
